import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';

import { RteNgModule } from '@innovation-os-ng/ui/rte';
import { TranslateModule, TranslateRegistry } from '@itonics/ngx-translate-simple';

import { TruncatePipe } from './pipes/truncate.pipe';

import { LegalContractService } from './contracts/legal-contract.service';
import { ApiLegalContractService } from './services/api-legal-contract.service';

import { DebounceClickDirective } from './directives/debounce-click.directive';
import { IfFeatureDirective } from './directives/if-feature.directive';
import { IfPermissionDirective } from './directives/if-permission.directive';
import { IfNotSubscriptionDirective, IfSubscriptionDirective } from './directives/if-subscription.directive';
import { TrackDirective } from './directives/track.directive';

import { LoggerErrorHandler } from './services/log.error-handler';

import { AgreementComponent } from './modals/agreement/agreement.component';
import { ErrorView } from './views/error/error.view';

import { CORE_DICTIONARY_EN } from './i18n/en';

import { AuthorizationNgModule } from '@innovation-os-ng/core/auth';
import { LoggerModule } from '@innovation-os-ng/core/logger';
import { UtilNgModule } from '@innovation-os-ng/core/utils';
import { ButtonModule } from '@innovation-os-ng/ui/button';
import { LoaderModule } from '@innovation-os-ng/ui/loader';
import { ModalContainerModule } from '@innovation-os-ng/ui/modal-container';
import { StaticNotificationModule } from '@innovation-os-ng/ui/static-notification';
import { TrialBannerComponent } from './components/trial-banner/trial-banner.component';
import { BillingService } from './contracts/billing.service';
import { PermissionService } from './contracts/permission.service';
import { TenantUserDetailsService } from './contracts/tenant-user-details.service';
import { LegalAgreementComponent } from './modals/legal-agreement-modal/legal-agreement-modal.component';
import { ApiBillingService } from './services/api-billing.service';
import { ApiPermissionService } from './services/api-permission.service';
import { ApiTenantUserDetailsService } from './services/api-tenant-user-details.service';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    RteNgModule,
    TranslateModule,
    LoggerModule,
    UtilNgModule,
    AuthorizationNgModule,
    ModalContainerModule,
    StaticNotificationModule,
    ButtonModule,
    LoaderModule,
    IfFeatureDirective,
    //Standalone components
    IfPermissionDirective
  ],
  declarations: [
    TruncatePipe,
    TrackDirective,
    DebounceClickDirective,

    IfSubscriptionDirective,
    IfNotSubscriptionDirective,
    AgreementComponent,
    LegalAgreementComponent,
    ErrorView,
    TrialBannerComponent
  ],
  exports: [
    TruncatePipe,
    TrackDirective,
    DebounceClickDirective,
    IfPermissionDirective,
    IfSubscriptionDirective,
    IfNotSubscriptionDirective,
    AgreementComponent,
    ErrorView,
    TrialBannerComponent,
    IfFeatureDirective
  ],
  providers: [
    { provide: ErrorHandler, useClass: LoggerErrorHandler },
    { provide: PermissionService, useClass: ApiPermissionService },
    { provide: LegalContractService, useClass: ApiLegalContractService },
    { provide: TenantUserDetailsService, useClass: ApiTenantUserDetailsService },
    { provide: BillingService, useClass: ApiBillingService }
  ]
})
export class CoreNgModule {
  constructor(translateRegistry: TranslateRegistry) {
    translateRegistry.registerLoader((lang) => Promise.resolve(CORE_DICTIONARY_EN));
  }
}
